import { getConsoleLogger } from '../util/logger';
import { scenario } from './scenarios/gmoney';

const consoleLogger = getConsoleLogger('responses');

export const { policies } = scenario; // for things that use our policies export (e.g. Device tests)

const countryValidationRulesValues = {
  iso2Code: 'US',
  defaultCulture: 'en-US',
  isStateRequired: true,
  supportedStatesList: [
    'AK',
    'AL',
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY',
  ],
  supportedLanguagesList: ['en', 'es'],
  supportedCulturesList: ['en-US', 'es-US'],
  isPostalCodeRequired: true,
  postalCodeRegex: '^\\d{5}(-\\d{4})?$',
  isCityRequired: true,
  isVatIdSupported: false,
  phoneNumberRegex:
    '^(1[ \\-\\/\\.]?)?(\\((\\d{3})\\)|(\\d{3}))[ \\-\\/\\.]?(\\d{3})[ \\-\\/\\.]?(\\d{4})$',
  isTaxIdSupported: true,
  isTaxIdOptional: true,
  countryCallingCodesList: ['1'],
};

export const countryValidationRules = countryValidationRulesValues;

export const defaultIvrPrompts = [
  {
    name: 'Welcome',
    videoPromptUrl:
      'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/RC_General_Welcome_1080p.png',
    audioInfos: [
      {
        name: 'Welcome audio',
        url: 'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/General_Welcome.wav',
      },
    ],
  },
  {
    name: 'Conference ID',
    videoPromptUrl:
      'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/RC_Meeting_DialIn_1080p.png',
    audioInfos: [
      {
        name: 'Enter Conference ID',
        url: 'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/Conference_NID.wav',
      },
      {
        name: 'Invalid Conference ID',
        url: 'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/Conference_NID_Invalid.wav',
      },
    ],
  },
  {
    name: 'Lobby',
    videoPromptUrl:
      'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/RC_Lobby_1080p.png',
    audioInfos: [
      {
        name: 'Waiting to be admitted',
        url: 'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/Aqua_lobby.wav',
      },
    ],
  },
  {
    name: 'Waiting for participants',
    videoPromptUrl:
      'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/Waiting_For_Participants_1080p.png',
  },
];

export const customIvrPrompts = [
  {
    name: 'Welcome',
    videoPromptUrl:
      'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/888888/en-US/RC_General_Welcome_1080p.jpg?t=2021-09-10T18%3A50%3A27.479Z',
    audioInfos: [
      {
        name: 'Welcome audio',
        url: 'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/888888/en-US/General_Welcome.wav?t=2021-09-10T18%3A50%3A27.479Z',
      },
    ],
  },
  {
    name: 'Conference ID',
    videoPromptUrl:
      'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/888888/en-US/RC_Meeting_DialIn_1080p.jpg?t=2021-09-10T18%3A50%3A27.479Z',
    audioInfos: [
      {
        name: 'Enter Conference ID',
        url: 'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/Conference_NID.wav',
      },
      {
        name: 'Invalid Conference ID',
        url: 'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/Conference_NID_Invalid.wav',
      },
    ],
  },
  {
    name: 'Lobby',
    videoPromptUrl:
      'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/RC_Lobby_1080p.png',
    audioInfos: [
      {
        name: 'Waiting to be admitted',
        url: 'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/Aqua_lobby.wav',
      },
    ],
  },
  {
    name: 'Waiting for participants',
    videoPromptUrl:
      'https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/Waiting_For_Participants_1080p.png',
  },
];

export const cspInvitationUrl =
  'https://portal.office.com/partner/partnersignup.aspx?type=ResellerRelationship&id=d0880d3f-e6d1-4a41-9e81-b8fbcddf7b6c&csp=1&msppid=0';

// ////////////////////////
let isLoggedIn = false;
let hasResellerRelationshipValue = false;
let hasDelegatedAdminPermissionValue = false;
let hasIncompleteBillingProfile = true;
let hasCloudAgreements = false;
let trialRequestedValue = false;
// ////////////////////////

export function establishResellerRelationship() {
  hasResellerRelationshipValue = true;
  hasDelegatedAdminPermissionValue = true;
}

export function getWhatNext(schema) {
  consoleLogger.debug('getWhatNext');
  return checkLogin(() => {
    const t = schema.tenants.first();
    return {
      upn: scenario.user.upn,
      name: scenario.user.name,
      action: 'status',
      tenant: t,
      cspInvitationLink: cspInvitationUrl,
      hasResellerRelationship: hasResellerRelationshipValue,
      hasDelegatedAdminPermission: hasDelegatedAdminPermissionValue,
      isSkypeSetupComplete: isSkypeSetupComplete(),
      organization: scenario.organization,
      user: scenario.user,
      trialRequested: trialRequestedValue,
    };
  });
}

export function acceptAgreement() {
  consoleLogger.debug('acceptAgreement');
  hasCloudAgreements = true;
}

export function getWhatNextSkype(schema) {
  consoleLogger.debug('getWhatNextSkype');
  if (!hasResellerRelationshipValue) {
    return {
      upn: scenario.user.upn,
      name: scenario.user.name,
      action: 'requestReseller',
      url: 'https://portal.office.com/partner/partnersignup.aspx?type=ResellerRelationship&id=d0880d3f-e6d1-4a41-9e81-b8fbcddf7b6c&csp=1&msppid=0',
      organization: scenario.organization,
      user: scenario.user,
    };
  }

  if (hasIncompleteBillingProfile) {
    return {
      upn: scenario.user.upn,
      name: scenario.user.name,
      action: 'createBillingProfile',
      billingProfile: scenario.billingProfile,
      countryValidationRulesValues,
      organization: scenario.organization,
      user: scenario.user,
    };
  }

  if (!hasCloudAgreements) {
    return {
      upn: scenario.user.upn,
      name: scenario.user.name,
      action: 'acceptCloudAgreement',
      organization: scenario.organization,
      user: scenario.user,
    };
  }

  const t = schema.tenants.first();
  return {
    upn: scenario.user.upn,
    name: scenario.user.name,
    action: 'status',
    tenant: t,
    cspInvitationLink: cspInvitationUrl,
    hasResellerRelationship: hasResellerRelationshipValue,
    hasDelegatedAdminPermission: hasDelegatedAdminPermissionValue,
    isSkypeSetupComplete: isSkypeSetupComplete(),
    organization: scenario.organization,
    user: scenario.user,
  };
}

function isSkypeSetupComplete() {
  return (
    hasResellerRelationshipValue &&
    hasCloudAgreements &&
    !hasIncompleteBillingProfile
  );
}

export function getBillingProfile() {
  consoleLogger.debug('getBillingProfile');
  return checkLogin(() => ({
    action: 'createBillingProfile',
    billingProfile: scenario.billingProfile,
    countryValidationRules: countryValidationRulesValues,
    upn: scenario.user.upn,
    name: scenario.user.name,
  }));
}

export function updateBillingProfile() {
  consoleLogger.debug('updateBillingProfile');
  return checkLogin(() => {
    hasIncompleteBillingProfile = false;
  });
}

export function getHybrid(schema) {
  consoleLogger.debug('getHybrid');
  return checkLogin(() => {
    const h = schema.hybridSettings.first();
    if (h === null) {
      return {
        action: 'cloudService',
        upn: scenario.user.upn,
        name: scenario.user.name,
      };
    }
    return {
      action: 'hybridOptions',
      upn: scenario.user.upn,
      name: scenario.user.name,
      hasCert: h.hasCert,
      certificateKey: h.certificateKey,
      skypeUser: h.skypeUser,
      skypeDomain: h.skypeDomain,
      skypeAddress: h.skypeAddress,
      skypePort: h.skypePort,
      stratusEmail: h.stratusEmail,
      subjectCN: h.subjectCN,
    };
  });
}

export function updateHybrid(schema) {
  consoleLogger.debug('updateHybrid');
  return checkLogin(() => {
    let h = schema.hybridSettings.first();
    if (h === null) {
      h = schema.hybridSettings.create(scenario.hybridSettings);
    } else {
      h.update(scenario.hybridSettings);
    }
    return h;
  });
}

export function confirmHybrid(schema) {
  consoleLogger.debug('confirmHybrid');
  return checkLogin(() => {
    let h = schema.hybridSettings.first();
    if (h === null) {
      h = schema.hybridSettings.create({
        stratusEmail: scenario.hybridSettings.stratusEmail,
        hasCert: false,
      });
    }
    return {
      action: 'hybridOptions',
      upn: scenario.user.upn,
      name: scenario.user.name,
      h,
    };
  });
}

export function initialize(server) {
  consoleLogger.debug('initialize');
  server.create('tenant', scenario.tenant);
}

function checkLogin(doThisFunction) {
  if (!isLoggedIn) {
    return {
      url: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?&client_id=d46cf366-f046-4291-9ecb-a00b8dc39a83&response_type=id_token+code&redirect_uri=http%3A%2F%2Flocalhost%3A8380%2Fbureaucrat%2Faadsso&response_mode=form_post&scope=.default+openid+profile&state=mock&nonce=mock',
      state: 'mock',
      action: 'login',
    };
  }
  return doThisFunction();
}

export function login() {
  consoleLogger.debug('login');
  isLoggedIn = true;
}

export function logout(schema) {
  consoleLogger.debug('logout');
  isLoggedIn = false;
  schema.tenants.first().update(scenario.tenant);
}

export function activateLicense(schema) {
  consoleLogger.debug('activateLicense');
  return checkLogin(() => {
    const t = schema.tenants.first();
    t.update({ internalLicenses: [scenario.licenseToActivate] });
    t.update({ isEulaAccepted: true });
  });
}

export function getTenantProfile(schema) {
  consoleLogger.debug('getTenantProfile');
  return checkLogin(() => {
    const tenant = schema.tenants.first();
    return {
      tenant,
      upn: scenario.user.upn,
      name: scenario.user.name,
      organization: scenario.organization,
      user: scenario.user,
      trialRequested: trialRequestedValue,
    };
  });
}

export function checkEdge() {
  consoleLogger.debug('checkEdge');
  return {
    serviceName: '_sip._tls.polycom.com',
    resolvedHost: 'cssacsip.polycom.com.',
    resolvedPort: 443,
    resolvedIp: '140.242.65.84',
    tcpConnect: true,
    tlsConnect: false,
    errorReason:
      'Socket connection timeout to cssacsip.polycom.com./140.242.65.84:443',
  };
}

export function requestTrial() {
  consoleLogger.debug('requestTrial');
  trialRequestedValue = true;
}

export const getTenantPrompts = () => customIvrPrompts;

export const getDefaultPrompts = () => defaultIvrPrompts;
